module.exports = __webpack_public_path__ + "static/flow-b3f7d66f1fb8111b55a667795e7a268d.svg";